export const GET_SERVICE_REQUEST_LIST_REQUEST = 'GET_SERVICE_REQUEST_LIST_REQUEST';
export const GET_SERVICE_REQUEST_LIST_SUCCESS = 'GET_SERVICE_REQUEST_LIST_SUCCESS';
export const GET_SERVICE_REQUEST_LIST_FAILURE = 'GET_SERVICE_REQUEST_LIST_FAILURE';

export const GET_SERVICE_REQUEST_DETAIL_REQUEST = 'GET_SERVICE_REQUEST_DETAIL_REQUEST';
export const GET_SERVICE_REQUEST_DETAIL_SUCCESS = 'GET_SERVICE_REQUEST_DETAIL_SUCCESS';
export const GET_SERVICE_REQUEST_DETAIL_FAILURE = 'GET_SERVICE_REQUEST_DETAIL_FAILURE';

export const CREATE_SERVICE_REQUEST_REQUEST = 'CREATE_SERVICE_REQUEST_REQUEST';
export const CREATE_SERVICE_REQUEST_SUCCESS = 'CREATE_SERVICE_REQUEST_SUCCESS';
export const CREATE_SERVICE_REQUEST_FAILURE = 'CREATE_SERVICE_REQUEST_FAILURE';

export const UPDATE_SERVICE_REQUEST_REQUEST = 'UPDATE_SERVICE_REQUEST_REQUEST';
export const UPDATE_SERVICE_REQUEST_SUCCESS = 'UPDATE_SERVICE_REQUEST_SUCCESS';
export const UPDATE_SERVICE_REQUEST_FAILURE = 'UPDATE_SERVICE_REQUEST_FAILURE';

export const DELETE_SERVICE_REQUEST_REQUEST = 'DELETE_SERVICE_REQUEST_REQUEST';
export const DELETE_SERVICE_REQUEST_SUCCESS = 'DELETE_SERVICE_REQUEST_SUCCESS';
export const DELETE_SERVICE_REQUEST_FAILURE = 'DELETE_SERVICE_REQUEST_FAILURE';

export const GET_SERVICE_REQUEST_FILTER_LIST_REQUEST = 'GET_SERVICE_REQUEST_FILTER_LIST_REQUEST';
export const GET_SERVICE_REQUEST_FILTER_LIST_SUCCESS = 'GET_SERVICE_REQUEST_FILTER_LIST_SUCCESS';
export const GET_SERVICE_REQUEST_FILTER_LIST_FAILURE = 'GET_SERVICE_REQUEST_FILTER_LIST_FAILURE';

export const GET_SERVICE_REQUEST_STATS_REQUEST = 'GET_SERVICE_REQUEST_STATS_REQUEST';
export const GET_SERVICE_REQUEST_STATS_SUCCESS = 'GET_SERVICE_REQUEST_STATS_SUCCESS';
export const GET_SERVICE_REQUEST_STATS_FAILURE = 'GET_SERVICE_REQUEST_STATS_FAILURE';

export const GET_SERVICE_REQUEST_LIST_BY_CUSTOMER_REQUEST = 'GET_SERVICE_REQUEST_LIST_BY_CUSTOMER_REQUEST';
export const GET_SERVICE_REQUEST_LIST_BY_CUSTOMER_SUCCESS = 'GET_SERVICE_REQUEST_LIST_BY_CUSTOMER_SUCCESS';
export const GET_SERVICE_REQUEST_LIST_BY_CUSTOMER_FAILURE = 'GET_SERVICE_REQUEST_LIST_BY_CUSTOMER_FAILURE';

export const GET_SERVICE_REQUEST_LIST_BY_TEAM_REQUEST = 'GET_SERVICE_REQUEST_LIST_BY_TEAM_REQUEST';
export const GET_SERVICE_REQUEST_LIST_BY_TEAM_SUCCESS = 'GET_SERVICE_REQUEST_LIST_BY_TEAM_SUCCESS';
export const GET_SERVICE_REQUEST_LIST_BY_TEAM_FAILURE = 'GET_SERVICE_REQUEST_LIST_BY_TEAM_FAILURE';

export const GET_SERVICE_REQUEST_LIST_BY_PROJECT_REQUEST = 'GET_SERVICE_REQUEST_LIST_BY_PROJECT_REQUEST';
export const GET_SERVICE_REQUEST_LIST_BY_PROJECT_SUCCESS = 'GET_SERVICE_REQUEST_LIST_BY_PROJECT_SUCCESS';
export const GET_SERVICE_REQUEST_LIST_BY_PROJECT_FAILURE = 'GET_SERVICE_REQUEST_LIST_BY_PROJECT_FAILURE';

export const GET_SERVICE_REQUEST_LIST_BY_STATUS_REQUEST = 'GET_SERVICE_REQUEST_LIST_BY_STATUS_REQUEST';
export const GET_SERVICE_REQUEST_LIST_BY_STATUS_SUCCESS = 'GET_SERVICE_REQUEST_LIST_BY_STATUS_SUCCESS';
export const GET_SERVICE_REQUEST_LIST_BY_STATUS_FAILURE = 'GET_SERVICE_REQUEST_LIST_BY_STATUS_FAILURE';

export const GET_SERVICE_REQUEST_LIST_BY_PRIORITY_REQUEST = 'GET_SERVICE_REQUEST_LIST_BY_PRIORITY_REQUEST';
export const GET_SERVICE_REQUEST_LIST_BY_PRIORITY_SUCCESS = 'GET_SERVICE_REQUEST_LIST_BY_PRIORITY_SUCCESS';
export const GET_SERVICE_REQUEST_LIST_BY_PRIORITY_FAILURE = 'GET_SERVICE_REQUEST_LIST_BY_PRIORITY_FAILURE';

export const GET_SERVICE_REQUEST_LIST_BY_TYPE_REQUEST = 'GET_SERVICE_REQUEST_LIST_BY_TYPE_REQUEST';
export const GET_SERVICE_REQUEST_LIST_BY_TYPE_SUCCESS = 'GET_SERVICE_REQUEST_LIST_BY_TYPE_SUCCESS';
export const GET_SERVICE_REQUEST_LIST_BY_TYPE_FAILURE = 'GET_SERVICE_REQUEST_LIST_BY_TYPE_FAILURE';


export const GET_SERVICE_REQUEST_COUNT_REQUEST = 'GET_SERVICE_REQUEST_COUNT_REQUEST';
export const GET_SERVICE_REQUEST_COUNT_SUCCESS = 'GET_SERVICE_REQUEST_COUNT_SUCCESS';
export const GET_SERVICE_REQUEST_COUNT_FAILURE = 'GET_SERVICE_REQUEST_COUNT_FAILURE';

export const REFRESH_SERVICE_REQUEST_REQUEST = 'REFRESH_SERVICE_REQUEST_REQUEST';

export const HOLD_OR_RESUME_SERVICE_REQUEST_REQUEST = 'HOLD_OR_RESUME_SERVICE_REQUEST_REQUEST';
export const HOLD_OR_RESUME_SERVICE_REQUEST_SUCCESS = 'HOLD_OR_RESUME_SERVICE_REQUEST_SUCCESS';
export const HOLD_OR_RESUME_SERVICE_REQUEST_FAILURE = 'HOLD_OR_RESUME_SERVICE_REQUEST_FAILURE';


export const HARD_CLOSE_SERVICE_REQUEST_REQUEST = 'HARD_CLOSE_SERVICE_REQUEST_REQUEST';
export const HARD_CLOSE_SERVICE_REQUEST_SUCCESS = 'HARD_CLOSE_SERVICE_REQUEST_SUCCESS';
export const HARD_CLOSE_SERVICE_REQUEST_FAILURE = 'HARD_CLOSE_SERVICE_REQUEST_FAILURE';

export const BULK_TICKET_CREATE_REQUEST = 'BULK_TICKET_CREATE_REQUEST'
export const BULK_TICKET_CREATE_SUCCESS = 'BULK_TICKET_CREATE_SUCCESS'

export const BULK_TICKET_EXAMPLE_FILE_REQUEST = 'BULK_TICKET_EXAMPLE_FILE_REQUEST'
export const BULK_TICKET_EXAMPLE_FILE_SUCCESS = 'BULK_TICKET_EXAMPLE_FILE_SUCCESS'
export const GET_ELIGIBLE_AGENTS_REQUEST = 'GET_ELIGIBLE_AGENTS_REQUEST';
export const GET_ELIGIBLE_AGENTS_SUCCESS = 'GET_ELIGIBLE_AGENTS_SUCCESS';
export const GET_ELIGIBLE_AGENTS_FAILURE = 'GET_ELIGIBLE_AGENTS_FAILURE';

// export const GET_ALL_TICKET_PAYMENT_REQUEST = 'GET_ALL_TICKET_PAYMENT_REQUEST';
// export const GET_ALL_TICKET_PAYMENTS_SUCCESS = 'GET_ALL_TICKET_PAYMENTS_SUCCESS'


export const ACCEPT_MILESTONE_REQUEST = 'ACCEPT_MILESTONE_REQUEST';
export const ACCEPT_MILESTONE_SUCCESS = 'ACCEPT_MILESTONE_SUCCESS';

export const ASSIGN_AGENTS_REQUEST = 'ASSIGN_AGENTS_REQUEST';
export const ASSIGN_AGENTS_SUCCESS = 'ASSIGN_AGENTS_SUCCESS';

export const REASSIGN_AGENTS_REQUEST = 'REASSIGN_AGENTS_REQUEST';
export const REASSIGN_AGENTS_SUCCESS = 'REASSIGN_AGENTS_SUCCESS';

export const BROADCAST_REQUEST = 'BROADCAST_REQUEST';
export const BROADCAST_SUCCESS = 'BROADCAST_SUCCESS';


export const SITE_COMPLETE_REQUEST = 'SITE_COMPLETE_REQUEST';
export const SITE_COMPLETE_SUCCESS = 'SITE_COMPLETE_SUCCESS';

export const EXECUTION_DATE_REQUEST = 'EXECUTION_DATE_REQUEST';
export const EXECUTION_DATE_SUCCESS = 'EXECUTION_DATE_SUCCESS';

export const GET_TICKET_PROGRESS = 'GET_TICKET_PROGRESS';

export const ASSIGN_HELPDESK_REQUEST = 'ASSIGN_HELPDESK_REQUEST';
export const ASSIGN_HELPDESK_SUCCESS = 'ASSIGN_HELPDESK_SUCCESS';

export const GET_SERVICE_REQUEST_BY_ID_REQUEST = 'GET_SERVICE_REQUEST_BY_ID_REQUEST';
export const GET_SERVICE_REQUEST_BY_ID_SUCCESS = 'GET_SERVICE_REQUEST_BY_ID_SUCCESS';


export const SERVICE_REQUEST_PAYMENT_CREATE_OR_EDIT_REQUEST = 'SERVICE_REQUEST_PAYMENT_CREATE_OR_EDIT_REQUEST';
export const SERVICE_REQUEST_PAYMENT_CREATE_OR_EDIT_SUCCESS = 'SERVICE_REQUEST_PAYMENT_CREATE_OR_EDIT_SUCCESS';
export const SERVICE_REQUEST_PAYMENT_CREATE_OR_EDIT_FAILURE = 'SERVICE_REQUEST_PAYMENT_CREATE_OR_EDIT_FAILURE';

export const SERVICE_REQUEST_PAYMENT_APPROVE_REQUEST = 'SERVICE_REQUEST_PAYMENT_APPROVE_REQUEST';
export const SERVICE_REQUEST_PAYMENT_APPROVE_SUCCESS = 'SERVICE_REQUEST_PAYMENT_APPROVE_SUCCESS';

export const SERVICE_REQUEST_PAYMENT_REJECT_REQUEST = 'SERVICE_REQUEST_PAYMENT_REJECT_REQUEST';
export const SERVICE_REQUEST_PAYMENT_REJECT_SUCCESS = 'SERVICE_REQUEST_PAYMENT_REJECT_SUCCESS';

export const SERVICE_REQUEST_PAYMENT_ROLLBACK_REQUEST = 'SERVICE_REQUEST_PAYMENT_ROLLBACK_REQUEST';
export const SERVICE_REQUEST_PAYMENT_ROLLBACK_SUCCESS = 'SERVICE_REQUEST_PAYMENT_ROLLBACK_SUCCESS';

export const GET_SERVICE_REQUEST_PAYMENTS_REQUEST = 'GET_SERVICE_REQUEST_PAYMENTS_REQUEST';
export const GET_SERVICE_REQUEST_PAYMENTS_SUCCESS = 'GET_SERVICE_REQUEST_PAYMENTS_SUCCESS';

export const GET_SERVICE_REQUEST_MILESTONES_REQUEST = 'GET_SERVICE_REQUEST_MILESTONES_REQUEST';
export const GET_SERVICE_REQUEST_MILESTONES_SUCCESS = 'GET_SERVICE_REQUEST_MILESTONES_SUCCESS';


export const REACHED_SITE_SERVICE_REQUEST_REQUEST = 'REACHED_SITE_SERVICE_REQUEST_REQUEST';
export const REACHED_SITE_SERVICE_REQUEST_SUCCESS = 'REACHED_SITE_SERVICE_REQUEST_SUCCESS';



export const APPROVE_TICKET_MILESTONE_REQUEST = 'APPROVE_TICKET_MILESTONE_REQUEST';
export const APPROVE_TICKET_MILESTONE_SUCCESS = 'APPROVE_TICKET_MILESTONE_SUCCESS';


export const REJECT_TICKET_MILESTONE_REQUEST = 'REJECT_TICKET_MILESTONE_REQUEST';
export const REJECT_TICKET_MILESTONE_SUCCESS = 'REJECT_TICKET_MILESTONE_SUCCESS';


export const TICKET_RAISE_SIGNOFF_REQUEST = 'TICKET_RAISE_SIGNOFF_REQUEST';
export const TICKET_RAISE_SIGNOFF_SUCCESS = 'TICKET_RAISE_SIGNOFF_SUCCESS';

export const SERVICE_REQUEST_TASK_UPDATE_REQUEST = 'SERVICE_REQUEST_TASK_UPDATE_REQUEST';
export const SERVICE_REQUEST_TASK_UPDATE_SUCCESS = 'SERVICE_REQUEST_TASK_UPDATE_SUCCESS';
export const SERVICE_REQUEST_TASK_UPDATE_FAILURE = 'SERVICE_REQUEST_TASK_UPDATE_FAILURE';

export const GET_ALL_TICKET_PAYMENTS_REQUEST = 'GET_ALL_TICKET_PAYMENTS_REQUEST';
export const GET_ALL_TICKET_PAYMENTS_SUCCESS = 'GET_ALL_TICKET_PAYMENTS_SUCCESS';

export const GET_SERVICE_REQUEST_BY_IDS_SUCCESS = 'GET_SERVICE_REQUEST_BY_IDS_SUCCESS';

export const UPDATE_RMA_REQUEST = 'UPDATE_RMA_REQUEST';
export const UPDATE_RMA_SUCCESS = 'UPDATE_RMA_SUCCESS';

export const MAP_FAULTY_ASSET_REQUEST = 'MAP_FAULTY_ASSET_REQUEST';
export const MAP_FAULTY_ASSET_SUCCESS = 'MAP_FAULTY_ASSET_SUCCESS';

export const TRIGGERED_SERVICE_REQUEST_REQUEST = 'TRIGGERED_SERVICE_REQUEST_REQUEST';
export const TRIGGERED_SERVICE_REQUEST_SUCCESS = 'TRIGGERED_SERVICE_REQUEST_SUCCESS';

export const GET_ELIGIBLE_ENGINEERS_REQUEST = 'GET_ELIGIBLE_ENGINEERS_REQUEST';
export const GET_ELIGIBLE_ENGINEERS_SUCCESS = 'GET_ELIGIBLE_ENGINEERS_SUCCESS';

export const UPDATE_REMARK_REQUEST = 'UPDATE_REMARK_REQUEST';
export const UPDATE_REMARK_SUCCESS = 'UPDATE_REMARK_SUCCESS';


export const ADD_ATTRIBUTES_REQUEST = 'ADD_ATTRIBUTES_REQUEST';
export const ADD_ATTRIBUTES_SUCCESS = 'ADD_ATTRIBUTES_SUCCESS';

export const SET_SERVICE_REQUEST_FILTER_PAYLOAD = 'SET_SERVICE_REQUEST_FILTER_PAYLOAD';


export const GET_EXTRA_DETAILS_BY_IDS_REQUEST = 'GET_EXTRA_DETAILS_BY_IDS_REQUEST';
export const GET_EXTRA_DETAILS_BY_IDS_SUCCESS = 'GET_EXTRA_DETAILS_BY_IDS_SUCCESS';

export const CLONE_SERVICE_REQUEST_REQUEST = 'CLONE_SERVICE_REQUEST_REQUEST';

export const UPLOAD_TASKS_AND_UPDATE = 'UPLOAD_TASKS_AND_UPDATE';

export const RELEASE_SERVICE_REQUEST = 'RELEASE_SERVICE_REQUEST';

export const ADD_BOQ_IN_SERVICE_REQUEST = 'ADD_BOQ_IN_SERVICE_REQUEST';

export const GOING_TO_SITE_SERVICE_REQUEST_REQUEST = 'GOING_TO_SITE_SERVICE_REQUEST_REQUEST';
export const GOING_TO_SITE_SERVICE_REQUEST_SUCCESS = 'GOING_TO_SITE_SERVICE_REQUEST_SUCCESS';

export const ADD_DOCKET_DETAILS_REQUEST = 'ADD_DOCKET_DETAILS_REQUEST';
export const ADD_DOCKET_DETAILS_SUCCESS = 'ADD_DOCKET_DETAILS_SUCCESS';

export const UPDATE_TRIGGERED_SERVICE_REQUEST_SUCCESS = 'UPDATE_TRIGGERED_SERVICE_REQUEST_SUCCESS';


export const GET_SERVICE_REQUEST_HISTORY_REQUEST = 'GET_SERVICE_REQUEST_HISTORY_REQUEST';
export const GET_SERVICE_REQUEST_HISTORY_SUCCESS = 'GET_SERVICE_REQUEST_HISTORY_SUCCESS';

export const ADD_MILESTONE_IN_SERVICE_REQUEST = 'ADD_MILESTONE_IN_SERVICE_REQUEST';
export const ADD_MILESTONE_IN_SERVICE_REQUEST_SUCCESS = 'ADD_MILESTONE_IN_SERVICE_REQUEST_SUCCESS';


export const BULK_SERVICE_REQUEST_STATE_CHANGE_REQUEST = 'BULK_SERVICE_REQUEST_STATE_CHANGE_REQUEST';

export const BULK_CLONE_SERVICE_REQUEST_REQUEST = 'BULK_CLONE_SERVICE_REQUEST_REQUEST';
export const BULK_DELETE_SERVICE_REQUEST_REQUEST = 'BULK_DELETE_SERVICE_REQUEST_REQUEST';
export const BULK_EDIT_EXECUTION_DATE_OF_SERVICE_REQUEST_REQUEST = 'BULK_EDIT_EXECUTION_DATE_OF_SERVICE_REQUEST_REQUEST';


export const BULK_ASSIGN_AGENTS_OF_SERVICE_REQUEST_REQUEST = 'BULK_ASSIGN_AGENTS_OF_SERVICE_REQUEST_REQUEST';


export const ADD_SERVICE_REQUEST_REMARK_REQUEST = 'ADD_SERVICE_REQUEST_REMARK_REQUEST';

export const UNLOCK_SIGN_OFF_SERVICE_REQUEST = 'UNLOCK_SIGN_OFF_SERVICE_REQUEST';
export const REMOVE_BULK_AGENTS_REQUEST = 'REMOVE_BULK_AGENTS_REQUEST'


export const GENERATE_SIGN_OFF_REPORT_REQUEST = 'GENERATE_SIGN_OFF_REPORT_REQUEST';
export const GENERATE_TICKET_REPORT_REQUEST = 'GENERATE_TICKET_REPORT_REQUEST';


export const UPDATE_NO_RESPONSE_REQUEST = 'UPDATE_NO_RESPONSE_REQUEST';
export const UPDATE_NO_RESPONSE_SUCCESS = 'UPDATE_NO_RESPONSE_SUCCESS';

export const SUPPORT_TRACK_TICKET_DETAILS_REQUEST = 'SUPPORT_TRACK_TICKET_DETAILS_REQUEST';
export const SUPPORT_TRACK_TICKET_DETAILS_SUCCESS = 'SUPPORT_TRACK_TICKET_DETAILS_SUCCESS';

export const GET_SERVICE_REQUEST_COUNT_V2 = 'GET_SERVICE_REQUEST_COUNT_V2';
export const GET_SERVICE_REQUEST_COUNT_V2_SUCCESS = 'GET_SERVICE_REQUEST_COUNT_V2_SUCCESS';

export const BULK_BROADCAST_REQUEST = 'BULK_BROADCAST_REQUEST';
export const BULK_BROADCAST_SUCCESS = 'BULK_BROADCAST_SUCCESS';

export const DOWNLOAD_CUSTOMER_SIGNOFF_REPORT_REQUEST = 'DOWNLOAD_CUSTOMER_SIGNOFF_REPORT_REQUEST';

export const CUSTOMER_APPROVAL_RECEIVED_REQUEST = 'CUSTOMER_APPROVAL_RECEIVED_REQUEST';
export const REVOKE_CUSTOMER_APPROVAL_REQUEST = 'REVOKE_CUSTOMER_APPROVAL_REQUEST';

export const GET_BILLING_REMARKS_REQUEST = 'GET_BILLING_REMARKS_REQUEST';
export const GET_BILLING_REMARKS_SUCCESS = 'GET_BILLING_REMARKS_SUCCESS';
export const GET_BILLING_REMARKS_FAILURE = 'GET_BILLING_REMARKS_FAILURE';
export const SET_BILLING_REMARKS_FILTER_PAYLOAD = 'SET_BILLING_REMARKS_FILTER_PAYLOAD';
export const REFRESH_BILLING_REMARKS_REQUEST = 'REFRESH_BILLING_REMARKS_REQUEST';
export const SET_PAYMENT_FILTER_PAYLOAD = 'SET_PAYMENT_FILTER_PAYLOAD';

export const EDIT_CUSTOMER_REPORT_REQUEST = 'EDIT_CUSTOMER_REPORT_REQUEST'

export const BULK_SIGN_OFF_UNLOCK_REQUEST = 'BULK_SIGN_OFF_UNLOCK_REQUEST';

export const SERVICE_REQUEST_PAYMENT_HOLD_REQUEST = 'SERVICE_REQUEST_PAYMENT_HOLD_REQUEST';
export const SERVICE_REQUEST_PAYMENT_HOLD_SUCCESS = 'SERVICE_REQUEST_PAYMENT_HOLD_SUCCESS';

export const REMOVE_ASSET_FROM_TICKET_REQUEST = 'REMOVE_ASSET_FROM_TICKET_REQUEST';
export const REMOVE_ASSET_FROM_TICKET_SUCCESS = 'REMOVE_ASSET_FROM_TICKET_SUCCESS';

export const FIX_RMA_REQUEST = 'FIX_RMA_REQUEST';

export const PAV_ASSET_PHYSICAL_VERIFICATION_REQUEST = 'PAV_ASSET_PHYSICAL_VERIFICATION_REQUEST';
export const PAV_ASSET_PHYSICAL_VERIFICATION_SUCCESS = 'PAV_ASSET_PHYSICAL_VERIFICATION_SUCCESS';

export const GET_SERVICE_REQUEST_COUNT_BY_STATUS_REQUEST = 'GET_SERVICE_REQUEST_COUNT_BY_STATUS_REQUEST';
export const GET_SERVICE_REQUEST_COUNT_BY_STATUS_SUCCESS = 'GET_SERVICE_REQUEST_COUNT_BY_STATUS_SUCCESS';


export const UPDATE_CUSTOMER_SIGNOFF_STATUS_REQUEST = 'UPDATE_CUSTOMER_SIGNOFF_STATUS_REQUEST';
export const UPDATE_CUSTOMER_SIGNOFF_STATUS_SUCCESS = 'UPDATE_CUSTOMER_SIGNOFF_STATUS_SUCCESS';

export const GET_VISIT_HISTORY_REQUEST = 'GET_VISIT_HISTORY_REQUEST';
export const GET_VISIT_HISTORY_SUCCESS = 'GET_VISIT_HISTORY_SUCCESS';

export const SET_PAYMENT_COUNT = 'SET_PAYMENT_COUNT';